<script>

</script>

<main>
    <p>
    first i must admit: several changes have been published between dec '23 and now. minor changes, but changes, compounded over time..
    </p>
    <p>
    i really had to pee when i set the last ♻️🪵 (change log) message. i just wanted to finish up, git push and git going. to briefly elaborate, the changelog will now document a wider scope of changes .. site-wise .. (my) life-wise .. idk + etc.
    </p>
    <p>
    but first... the code needed a severe spring cleaning. stuff you can't really notice, per my goal: to make my spaghetti code more elegant without breaking the website. it was walking on a tightrope before. these changelogs previously only supported a single string of text. no paragraphs, images, nada. now, it's (🤞) set up to scale easier.. (faster...) 
    </p>
    <p>
    nonetheless, i think we will continue to develop furiously, embracing imperfections like the weird flicker at the start of the page. the lag when you open foco. these are the loose strings and open stitches that a seamstress hides on the inside of a dress, but when they poke out a bit, you get a glimpse of the magic that held the whole thing together in the first place.
    </p>

    <p>
    at least that's what i'll tell myself :)
    </p>

</main>